(function() {
  // transform tabs
  var $tabHeaders = $('.tab-header');
  var $tabContents = $('.tab-content');
  var i= 0;
  var expandFirst = false;
  $tabHeaders.each(function(){
    var $header = $(this);
    var $content = $(this).next('.tab-content');

    var header = $header.html();
    var content = $content.html();    

// ClueEdit: SEO Structural Heading
if ($('body').hasClass('template-product')) {
  header = `<h2>${header}</h2>`;
}

    var newTabHtml = `
      <div class="Collapsible">
        <div class="Collapsible__Button" data-action="toggle-collapsible" aria-expanded="${((i===0 && expandFirst)?'true':'false')}">${header}<span class="Collapsible__Plus"></span>
        </div>
          <div class="Collapsible__Inner" style="${((i===0 && expandFirst)?'overflow: visible; height: auto;':'')}">
          <div class="Collapsible__Content">${content}</div>
        </div>
      </div>
    `;
    $(newTabHtml).insertAfter($content);
    i++;
  });


//   remove existing header & contents
  $tabHeaders.remove();
  $tabContents.remove();  
}());


